import styled from "styled-components";

const pageviewsChartWrapper = styled.div`
  .analytics-processwidget-card {
    background-color: white;
    height: 100%;
    .header {
      padding: 24px;
      letter-spacing: 0.02em;
    }

    .desc1 {
      margin: 10px 0;
      font-size: 20px;
      line-height: 1;
      letter-spacing: 0.02em;
    }

    .desc2 {
      color: #9e9e9e;
      font-size: 16px;
      font-weight: 400;
    }
  }
`;

export default pageviewsChartWrapper;
